import Loads from "./Loads.jsx";

export default Loads;
